import React from 'react';
import Modal from "react-bootstrap/Modal";
import styles from "./modal.module.css";
import { ExclamationTriangle } from 'react-bootstrap-icons';
import AppData from "../3d/app.data";
import Button from '../molecules/Button';

type Props = {
    show: boolean;
    onHide: () => void;
    onRemove: (skip: boolean, space: number) => void;
    space: number;
}

const appData = new AppData()

export const ConfirmDeleteHexagonModal = ({show, onHide, onRemove, space}: Props) => {
    const [includeArtworks, setIncludesArtworks] = React.useState(false);
    const [skipDialog, setSkipDialog] = React.useState<boolean>(false);
    

    React.useEffect(() => {
        const artworksToRemove = appData.galleryData.artworkWrappers.filter(m => m.galleryBelongsTo === `Space-${space+1}`)
        console.log("artworks in modal: ", artworksToRemove);
        setIncludesArtworks(artworksToRemove.length > 0);
    }, [])

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Body className={styles.background}>
                <div className="m-5">
                    <div className="text-center mb-3">
                        <ExclamationTriangle size={"100"} color="#dde336"/>
                    </div>
                    <h4 className="text-center fs-5 mb-1">Are sure to remove this hexagon?</h4>
                    <h6 className="text-center fs-6 mb-3">This will return the artworks in this hexagon to your artworks repository.</h6>
                    <div className='my-1 mx-5'>
                        <input className='mx-2' id='skip' type='checkbox' checked={skipDialog} onChange={e => setSkipDialog(e.target.checked)}/>
                        <label htmlFor='skip'>Don't show this again</label>
                    </div>
                    <div className="d-flex justify-content-center mt-5">
                        <Button small className='me-4 btn btn-success' onClick={onHide}>
                            Cancel
                        </Button>
                        <Button small onClick={() => onRemove(skipDialog, space)} className='btn btn-success'>Remove</Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}